import type { CaseExercise } from "../types";

interface CaseSwitcherProps {
  cases: CaseExercise[];
  activeId: string;
  onSelect: (id: string) => void;
}

export function CaseSwitcher({ cases, activeId, onSelect }: CaseSwitcherProps) {
  return (
    <nav className="case-switcher" aria-label="Fälle">
      {cases.map((caseExercise) => (
        <button
          className={caseExercise.id === activeId ? "is-active" : ""}
          key={caseExercise.id}
          onClick={() => onSelect(caseExercise.id)}
          type="button"
        >
          {caseExercise.title}
        </button>
      ))}
    </nav>
  );
}
